import { Spinner } from "reactstrap";
import { useEffect } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import PaymentCard from "../PaymentCard";
import FormikInput from "../FormikInput";
import DropdownItem from "../DropdownItem";
import Dropdown from "../Dropdown";

import { getCards } from "@redux/paymentCards/actions";

import { useField } from "formik";

import styles from "./index.module.scss";

const SelectCardDropdown = ({
  direction,
  usePortal,
  setIsDropDownOpen,
  isCardsLoading,
  isDropDownOpen,
  name,
  onCardIdChange,
  wrapperClassname,
  menuClassName = "w-100",
}) => {
  const dispatch = useDispatch();

  const { allCards } = useSelector(({ cardsReducer }) => cardsReducer);

  useEffect(() => {
    dispatch(getCards());
  }, []);

  const [{ value: cardId }, {}, { setValue }] = useField({
    name,
    type: "text",
  });

  useEffect(() => {
    if (allCards?.length && !cardId) {
      setValue(allCards[0]);
    }
  }, [allCards?.length, cardId]);

  return isCardsLoading ? (
    <Spinner className="mx-auto my-2" />
  ) : (
    <div className="d-flex">
      <Dropdown
        caret
        direction={direction}
        usePortal={usePortal}
        togglerClassName="btn-resetStyle mw-100 w-100"
        wrapperClassName={classNames(
          "w-100",
          wrapperClassname,
          !allCards.length && "d-none",
        )}
        menuClassName={menuClassName}
        onOpen={() => setIsDropDownOpen(true)}
        onClose={() => setIsDropDownOpen(false)}
        toggler={
          cardId ? (
            <div
              className={classNames(
                styles.cardSelected,
                isDropDownOpen && styles.cardActive,
                "d-flex",
              )}
            >
              <PaymentCard short id={cardId} />
            </div>
          ) : (
            <FormikInput
              readOnly
              name={name}
              placeholder=""
              wrapperClassName="pe-none pb-0 w-100"
            />
          )
        }
      >
        {allCards.map((id) => (
          <DropdownItem
            key={id}
            isSelected={cardId === id}
            onClick={() => {
              setValue(id);
              onCardIdChange?.(id);
            }}
          >
            <PaymentCard short id={id} />
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
};

export default SelectCardDropdown;
